export default __webpack_public_path__ + "iconMenu.55f6849429de279d473c459c7ead3249.svg";